import { FC } from 'react'
import { useTheme } from '@emotion/react'

// hooks
import { useAppSelector, useAppDispatch } from '@/hooks'
// features
import {
  ArtistListOnboardingRecommended,
  onboardingSelectError,
  onboardingSetPrevStage,
} from '@/features'
// icons
import { icons } from '@/assets'
// components
import { ButtonRound, Subtitle, Error } from '@/components'

// components
import { Form } from './components'
// styles
import { styles } from './styles'

type FollowArtistsProps = {}

export const FollowArtists: FC<FollowArtistsProps> = () => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const onboardingError = useAppSelector(onboardingSelectError)

  return (
    <div css={styles(theme).stage.main}>
      <div css={styles(theme).stage.backward.button}>
        <ButtonRound
          aria-label="set previous onboarding stage"
          appearance="secondary"
          onClick={() => dispatch(onboardingSetPrevStage())}
        >
          <icons.ArrowLeft css={styles(theme).stage.backward.icon} />
        </ButtonRound>
      </div>

      <div css={styles(theme).stage.content.main}>
        <div css={styles(theme).stage.content.title}>
          <Subtitle text="Go ahead and follow the artists we think you'll like!" />
        </div>

        <div css={styles(theme).stage.content.artists.main}>
          <div css={styles(theme).stage.content.artists.overlay.top} />
          <ArtistListOnboardingRecommended />
          <div css={styles(theme).stage.content.artists.overlay.bot} />
        </div>

        <div css={styles(theme).stage.content.form}>
          <Form />
        </div>

        <div css={styles(theme).stage.content.error}>
          <Error error={onboardingError} />
        </div>
      </div>
    </div>
  )
}

FollowArtists.propTypes = {}
